var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrap"},[_c('Lnb'),_c('div',{class:['flexible-content', _vm.heightMaxClass]},[_c('div',{staticClass:"app-content",attrs:{"id":"content","role":"main"}},[_c('Header'),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }